
import { keymap } from '@/config'
import { localGet, localSet } from 'essential/store/localStore'
import { computed, defineComponent, onDeactivated, shallowRef, watchEffect } from 'vue'

export default defineComponent({
  name: 'GuideTarget',
  props: {
    name: {
      type: String,
      requiredF: true,
    },
    hide: Boolean,
  },
  setup (props) {
    const key = keymap.guide[props.name as keyof typeof keymap.guide]

    const haveDisplayHistory = shallowRef(!key || (key && Boolean(localGet(key))))

    const show = computed(() => !props.hide && !haveDisplayHistory.value)

    const read = () => {
      localSet(key, '1')
    }

    watchEffect(() => {
      if (show.value) {
        read()
      }
    })

    onDeactivated(() => {
      read()
      haveDisplayHistory.value = true
    })

    return { show }
  },
})
